import { render } from "./LeaveBalancesView.vue?vue&type=template&id=5fb89456&scoped=true"
import script from "./LeaveBalancesView.vue?vue&type=script&lang=js"
export * from "./LeaveBalancesView.vue?vue&type=script&lang=js"

import "./LeaveBalancesView.vue?vue&type=style&index=0&id=5fb89456&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb89456"]])

export default __exports__